import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Alert, Button, Grow, Stack, TextField } from '@rossum/ui/material';
import { FeatureId } from '../feature-enablement/features';

type FeatureFeedbackCollectorProps = {
  featureId: FeatureId;
  onFeedbackSubmit: (featureId: FeatureId, feedback: string) => void;
  onFeedbackReject: (featureId: FeatureId) => void;
  showPrompt: boolean;
};

export const FeatureFeedbackCollector = ({
  featureId,
  onFeedbackSubmit,
  onFeedbackReject,
  showPrompt,
}: FeatureFeedbackCollectorProps) => {
  const intl = useIntl();
  const [feedback, setFeedback] = useState('');

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ pb: 2 }}
      data-cy={`feature-feedback-collector-${featureId}`}
    >
      <Grow in={showPrompt} appear unmountOnExit>
        <Alert
          severity="warning"
          variant="outlined"
          action={
            <Button
              variant="text"
              color="inherit"
              onClick={() => onFeedbackReject(featureId)}
              sx={{ alignSelf: 'flex-start', marginTop: -0.5 }}
              data-cy="feedback-collector-reject-button"
            >
              {intl.formatMessage({
                id: 'components.featureFeedbackCollector.noThanks',
              })}
            </Button>
          }
        >
          {intl.formatMessage({
            id: 'components.featureFeedbackCollector.prompt',
          })}
        </Alert>
      </Grow>
      <TextField
        fullWidth
        autoFocus
        multiline
        rows={3}
        placeholder={intl.formatMessage({
          id: 'components.featureFeedbackCollector.placeholder',
        })}
        value={feedback}
        onChange={e => setFeedback(e.target.value)}
      />
      <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          onClick={() => onFeedbackReject(featureId)}
          data-cy="feedback-collector-cancel-button"
        >
          {intl.formatMessage({
            id: 'components.featureFeedbackCollector.cancel',
          })}
        </Button>
        <Button
          variant="contained"
          onClick={() => onFeedbackSubmit(featureId, feedback)}
          data-cy="feedback-collector-submit-button"
        >
          {intl.formatMessage({
            id: 'components.featureFeedbackCollector.submit',
          })}
        </Button>
      </Stack>
    </Stack>
  );
};
